// src/components/CapoOfficina/CapoOfficinaRapportinoForm.jsx
import React, { useState, useEffect } from 'react';
import { 
  collection, 
  getDocs, 
  addDoc, 
  updateDoc, 
  doc, 
  serverTimestamp,
  Timestamp,
  query,
  where
} from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';
import { 
  getLavorazioniMeccanico, 
  createLavorazioneMeccanico 
} from '../../services/lavorazioniMeccanicoService';
import { MezziAutocomplete } from '../Admin/Cantieri/AutocompleteComponents'; 
import './capoofficina.css';
import LavorazioniAutocomplete from './LavorazioniAutocomplete';

const CapoOfficinaRapportinoForm = ({ rapportino, onBack, onSave }) => {
  const { currentUser } = useAuth();
  
  // Stati form dati
  const [formData, setFormData] = useState({
    data: new Date().toISOString().split('T')[0],
    personalePresente: [],
    lavorazioni: [],
    noteVarie: ''
  });

  // Stati supporto dati
  const [meccanici, setMeccanici] = useState([]);
  const [mezzi, setMezzi] = useState([]);
  const [lavorazioniDisponibili, setLavorazioniDisponibili] = useState([]);
  
  // Stati UI
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });
  
  // Stati per aggiungere personale
  const [selectedMeccanicoId, setSelectedMeccanicoId] = useState('');
  
// Stati per aggiungere lavorazione
const [showAddLavorazione, setShowAddLavorazione] = useState(false);
const [newLavorazione, setNewLavorazione] = useState({
  mezzoId: '',
  tipoLavorazione: '',
  tipoLavorazioneId: '', // ✅ AGGIUNTO: per salvare l'ID
  oreInvestite: '',
  personaleAssegnato: [],
  kmMezzo: '',
  note: '',
  status: 'Lavorazione in corso' // ✅ AGGIUNTO: status di default
});
const [searchLavorazione, setSearchLavorazione] = useState(''); // ✅ AGGIUNTO: per autocomplete
const [isCreatingLavorazione, setIsCreatingLavorazione] = useState(false); // ✅ AGGIUNTO: flag creazione
const [selectedMezzoId, setSelectedMezzoId] = useState(''); // ✅ AGGIUNTO: mezzo selezionato per autocomplete
const [showNuovaLavorazioneModal, setShowNuovaLavorazioneModal] = useState(false); // ✅ AGGIUNTO: modal creazione lavorazione
const [nuovaLavorazioneNome, setNuovaLavorazioneNome] = useState(''); // ✅ AGGIUNTO: nome nuova lavorazione nel modal
  // Caricamento dati iniziale
  useEffect(() => {
    loadInitialData();
  }, []);

        // ✅ NUOVO: Sincronizza la selezione del mezzo con l'autocomplete
useEffect(() => {
    if (selectedMezzoId !== newLavorazione.mezzoId) {
      setSelectedMezzoId(newLavorazione.mezzoId);
    }
  }, [newLavorazione.mezzoId]);

  // Carica rapportino esistente
  useEffect(() => {
    if (rapportino) {
      setFormData({
        data: rapportino.data instanceof Date 
          ? rapportino.data.toISOString().split('T')[0]
          : new Date(rapportino.data).toISOString().split('T')[0],
        personalePresente: rapportino.personalePresente || [],
        lavorazioni: rapportino.lavorazioni || [],
        noteVarie: rapportino.noteVarie || ''
      });
    }
  }, [rapportino]);

  const loadInitialData = async () => {
    try {
      setIsLoading(true);
      
      // Carica meccanici
      const meccaniciQuery = query(
        collection(db, 'users'),
        where('incarico', '==', 'Meccanico')
      );
      const meccaniciSnapshot = await getDocs(meccaniciQuery);
      const meccaniciList = meccaniciSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        displayName: `${doc.data().nome || ''} ${doc.data().cognome || ''}`.trim()
      }));
      setMeccanici(meccaniciList);
      
      // Carica mezzi
      const mezziSnapshot = await getDocs(collection(db, 'mezzi'));
      const mezziList = mezziSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setMezzi(mezziList);
      
      // Carica lavorazioni
      const lavorazioni = await getLavorazioniMeccanico();
      setLavorazioniDisponibili(lavorazioni);
      
      console.log(`Caricati: ${meccaniciList.length} meccanici, ${mezziList.length} mezzi, ${lavorazioni.length} lavorazioni`);
    } catch (error) {
      console.error('Errore nel caricamento dati:', error);
      showNotification('Errore nel caricamento dati', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  // ========================================
// CREA NUOVA LAVORAZIONE AL VOLO
// ========================================

const handleCreateLavorazioneAlVolo = async (nomeLavorazione) => {
  if (isCreatingLavorazione) return; // Previeni doppia creazione
  
  try {
    setIsCreatingLavorazione(true);
    showNotification('Creazione nuova lavorazione in corso...', 'info');
    
    // Crea la lavorazione nel database
    const nuovaLavorazione = await createLavorazioneMeccanico({
      nome: nomeLavorazione.trim(),
      descrizione: 'Creata da rapportino officina',
      createdAt: new Date(),
      createdBy: currentUser?.uid || 'system'
    });
    
    // Aggiorna la lista locale
    const lavorazioniAggiornate = [...lavorazioniDisponibili, nuovaLavorazione];
    setLavorazioniDisponibili(lavorazioniAggiornate);
    
    // Seleziona automaticamente la nuova lavorazione
    setNewLavorazione(prev => ({
      ...prev,
      tipoLavorazione: nuovaLavorazione.nome,
      tipoLavorazioneId: nuovaLavorazione.id
    }));
    
    setSearchLavorazione('');
    showNotification(`✅ Lavorazione "${nomeLavorazione}" creata con successo!`, 'success');
    
  } catch (error) {
    console.error('Errore nella creazione lavorazione:', error);
    showNotification('❌ Errore nella creazione della lavorazione', 'error');
  } finally {
    setIsCreatingLavorazione(false);
  }
};


// ========================================
// SELEZIONA LAVORAZIONE DA AUTOCOMPLETE
// ========================================

const handleSelectLavorazione = (lavorazione) => {
  setNewLavorazione(prev => ({
    ...prev,
    tipoLavorazione: lavorazione.nome || lavorazione.nomeLavorazione,
    tipoLavorazioneId: lavorazione.id
  }));
  setSearchLavorazione('');
};

  const showNotification = (message, type = 'success') => {
    setNotification({ show: true, message, type });
    setTimeout(() => {
      setNotification({ show: false, message: '', type: '' });
    }, 4000);
  };

  // ========================================
  // FUNZIONE HELPER: Rimuove campi undefined
  // ========================================
  const removeUndefinedFields = (obj) => {
    // Se è un array, applica ricorsivamente
    if (Array.isArray(obj)) {
      return obj.map(item => removeUndefinedFields(item));
    }
    
    // ✅ AGGIUNTO: Preserva Timestamp di Firestore
    if (obj instanceof Timestamp) {
      return obj;
    }
    
    // ✅ AGGIUNTO: Preserva altri tipi speciali Firestore
    if (obj && typeof obj.toDate === 'function') {
      return obj;
    }
    
    // Se è un oggetto, rimuovi campi undefined
    if (obj !== null && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc, key) => {
        const value = obj[key];
        if (value !== undefined) {
          acc[key] = removeUndefinedFields(value);
        }
        return acc;
      }, {});
    }
    
    // Ritorna il valore così com'è
    return obj;
  };

  // Gestione personale
  const handleAddPersonale = () => {
    if (!selectedMeccanicoId) {
      showNotification('Seleziona un meccanico', 'error');
      return;
    }

    const meccanico = meccanici.find(m => m.id === selectedMeccanicoId);
    if (!meccanico) {
      showNotification('Meccanico non trovato', 'error');
      return;
    }

    const esisteGia = formData.personalePresente.some(p => p.personaId === selectedMeccanicoId);
    if (esisteGia) {
      showNotification('Questo meccanico è già presente', 'error');
      return;
    }

    setFormData(prev => ({
      ...prev,
      personalePresente: [
        ...prev.personalePresente,
        {
          personaId: meccanico.id,
          nome: meccanico.nome || '',
          cognome: meccanico.cognome || '',
          incarico: meccanico.incarico || 'Meccanico'
        }
      ]
    }));

    setSelectedMeccanicoId('');
  };

  const handleRemovePersonale = (index) => {
    setFormData(prev => ({
      ...prev,
      personalePresente: prev.personalePresente.filter((_, i) => i !== index)
    }));
  };

  // Gestione lavorazioni
  const handleAddLavorazione = () => {
    if (!newLavorazione.mezzoId) {
      showNotification('Seleziona un mezzo', 'error');
      return;
    }

    if (!newLavorazione.tipoLavorazione) {
      showNotification('Seleziona il tipo di lavorazione', 'error');
      return;
    }

    if (!newLavorazione.oreInvestite || parseFloat(newLavorazione.oreInvestite) <= 0) {
      showNotification('Inserisci le ore investite', 'error');
      return;
    }

    const mezzo = mezzi.find(m => m.id === newLavorazione.mezzoId);
    if (!mezzo) {
      showNotification('Mezzo non trovato', 'error');
      return;
    }

    const lavorazioneCompleta = {
        lavorazioneId: `lav_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`, // ✅ ID univoco
        mezzoId: mezzo.id,
        nomeMezzo: mezzo.nomeMezzo,
        targaMezzo: mezzo.targa || '',
        tipoLavorazione: newLavorazione.tipoLavorazione,
        tipoLavorazioneId: newLavorazione.tipoLavorazioneId,
        status: newLavorazione.status,                    // ✅ AGGIUNTO
        oreInvestite: parseFloat(newLavorazione.oreInvestite),
        personaleAssegnato: newLavorazione.personaleAssegnato,
        kmMezzo: newLavorazione.kmMezzo,
        note: newLavorazione.note,
        dataInizio: newLavorazione.dataInizio,           // ✅ AGGIUNTO
        dataFine: newLavorazione.dataFine                // ✅ AGGIUNTO
      };
      
    setFormData(prev => ({
      ...prev,
      lavorazioni: [...prev.lavorazioni, lavorazioneCompleta]
    }));

// Reset form lavorazione
setNewLavorazione({
    mezzoId: '',
    tipoLavorazione: '',
    status: 'Lavorazione in corso',
    oreInvestite: '',
    personaleAssegnato: [],
    kmMezzo: '',
    note: '',
    dataInizio: new Date(),
    dataFine: null
  });
  setSelectedMezzoId('');  // ✅ AGGIUNTO
  setShowAddLavorazione(false);
  };

  const handleRemoveLavorazione = (index) => {
    setFormData(prev => ({
      ...prev,
      lavorazioni: prev.lavorazioni.filter((_, i) => i !== index)
    }));
  };

  // Gestione personale assegnato a lavorazione
  const handleTogglePersonaleAssegnato = (personaId) => {
    const persona = formData.personalePresente.find(p => p.personaId === personaId);
    if (!persona) return;

    const esisteGia = newLavorazione.personaleAssegnato.some(p => p.personaId === personaId);

    if (esisteGia) {
      setNewLavorazione(prev => ({
        ...prev,
        personaleAssegnato: prev.personaleAssegnato.filter(p => p.personaId !== personaId)
      }));
    } else {
      setNewLavorazione(prev => ({
        ...prev,
        personaleAssegnato: [...prev.personaleAssegnato, persona]
      }));
    }
  };

  const handleAssegnaTutti = () => {
    setNewLavorazione(prev => ({
      ...prev,
      personaleAssegnato: [...formData.personalePresente]
    }));
  };

  // Creazione nuova lavorazione custom
  const handleCreateNuovaLavorazione = async () => {
    if (!nuovaLavorazioneNome.trim()) {
      showNotification('Inserisci il nome della lavorazione', 'error');
      return;
    }

    try {
      const nuovaLav = await createLavorazioneMeccanico(nuovaLavorazioneNome);
      setLavorazioniDisponibili(prev => [...prev, nuovaLav]);
      setNewLavorazione(prev => ({ ...prev, tipoLavorazione: nuovaLav.nome }));
      setNuovaLavorazioneNome('');
      setShowNuovaLavorazioneModal(false);
      showNotification('✅ Nuova lavorazione creata', 'success');
    } catch (error) {
      console.error('Errore creazione lavorazione:', error);
      showNotification('Errore nella creazione della lavorazione', 'error');
    }
  };

  // Salvataggio rapportino
  const handleSave = async () => {
    if (!formData.data) {
      showNotification('Inserisci la data', 'error');
      return;
    }

    if (formData.personalePresente.length === 0) {
      showNotification('Aggiungi almeno una persona', 'error');
      return;
    }

    try {
      setIsSaving(true);

      // Prepara i dati base
// ✅ SPLIT e converti correttamente
const [year, month, day] = formData.data.split('-').map(Number);
      const dataDate = new Date(year, month - 1, day);

      const rapportinoData = {
        data: Timestamp.fromDate(dataDate),
        personalePresente: formData.personalePresente || [],
        lavorazioni: formData.lavorazioni || [],
        noteVarie: formData.noteVarie || '',
        redattoDa: currentUser.uid,
        redattoDaNome: `${currentUser.nome || ''} ${currentUser.cognome || ''}`.trim() || currentUser.email,
        stato: 'Attivo',
        updatedAt: serverTimestamp()
      };

      // ✅ Pulisci undefined
      const cleanData = removeUndefinedFields(rapportinoData);

      if (rapportino) {
        // Aggiornamento
        const rapportinoRef = doc(db, 'rapportiniOfficina', rapportino.id);
        await updateDoc(rapportinoRef, cleanData);
        showNotification('✅ Rapportino aggiornato con successo', 'success');
      } else {
        // Creazione
        cleanData.createdAt = serverTimestamp();
        await addDoc(collection(db, 'rapportiniOfficina'), cleanData);
        showNotification('✅ Rapportino creato con successo', 'success');
      }

      setTimeout(() => {
        onSave();
      }, 1500);
    } catch (error) {
      console.error('Errore nel salvataggio rapportino:', error);
      showNotification('Errore nel salvataggio del rapportino', 'error');
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) {
    return (
      <div className="loading-state">
        <div className="spinner"></div>
        <p>Caricamento dati...</p>
      </div>
    );
  }

  return (
    <div className="rapportino-form-container">
      <div className="rapportino-form-header">
        <button onClick={onBack} className="btn-back">
          ← Indietro
        </button>
        <h2>{rapportino ? 'Modifica Rapportino' : 'Nuovo Rapportino Officina'}</h2>
      </div>

      {notification.show && (
        <div className={`notification ${notification.type}`}>
          {notification.message}
        </div>
      )}

      <div className="rapportino-form-content">
        {/* Sezione Data */}
        <div className="form-section">
          <h3>📅 Data Rapportino</h3>
          <input
            type="date"
            value={formData.data}
            onChange={(e) => setFormData(prev => ({ ...prev, data: e.target.value }))}
            className="form-input"
          />
        </div>

        {/* Sezione Personale */}
        <div className="form-section">
          <h3>👥 Personale Presente</h3>
          
          <div className="add-item-form">
            <select
              value={selectedMeccanicoId}
              onChange={(e) => setSelectedMeccanicoId(e.target.value)}
              className="form-select"
            >
              <option value="">Seleziona meccanico...</option>
              {meccanici.map(mecc => (
                <option key={mecc.id} value={mecc.id}>
                  {mecc.displayName}
                </option>
              ))}
            </select>
            <button onClick={handleAddPersonale} className="btn-add">
              ➕ Aggiungi
            </button>
          </div>

          {formData.personalePresente.length > 0 && (
            <div className="items-list">
              {formData.personalePresente.map((persona, index) => (
                <div key={index} className="item-card">
                  <div className="item-info">
                    <strong>{persona.nome} {persona.cognome}</strong>
                    <span className="badge">{persona.incarico}</span>
                  </div>
                  <button
                    onClick={() => handleRemovePersonale(index)}
                    className="btn-remove"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Sezione Lavorazioni */}
        <div className="form-section">
          <h3>🔧 Lavorazioni Effettuate</h3>

          {!showAddLavorazione ? (
            <button
              onClick={() => setShowAddLavorazione(true)}
              className="btn-add-lavorazione"
              disabled={formData.personalePresente.length === 0}
            >
              ➕ Aggiungi Lavorazione
            </button>
          ) : (
            <div className="lavorazione-form">
<div className="form-row">
  {/* ✅ SOSTITUITO: Select con MezziAutocomplete */}
  <div className="form-group">
    <MezziAutocomplete
      mezzi={mezzi}
      selectedMezzo={selectedMezzoId}
      setSelectedMezzo={setSelectedMezzoId}
      onSelect={(mezzo) => {
        if (mezzo) {
          setNewLavorazione(prev => ({ ...prev, mezzoId: mezzo.id }));
        } else {
          setNewLavorazione(prev => ({ ...prev, mezzoId: '' }));
        }
      }}
      placeholder="🔍 Cerca per nome o targa..."
      label="Mezzo *"
      required={true}
    />
  </div>

  <div className="form-group">
  <label>Tipo Lavorazione *</label>
  <LavorazioniAutocomplete
    lavorazioni={lavorazioniDisponibili}
    value={searchLavorazione}
    onChange={setSearchLavorazione}
    onSelect={handleSelectLavorazione}
    onCreateNew={handleCreateLavorazioneAlVolo}
    placeholder="🔍 Cerca o crea lavorazione..."
    disabled={isCreatingLavorazione}
  />
  
  {/* ✅ Mostra la lavorazione selezionata */}
  {newLavorazione.tipoLavorazione && (
    <div className="selected-lavorazione-badge">
      <span className="badge-icon">🔧</span>
      <span className="badge-text">{newLavorazione.tipoLavorazione}</span>
      <button
        type="button"
        className="badge-remove"
        onClick={() => {
          setNewLavorazione(prev => ({
            ...prev,
            tipoLavorazione: '',
            tipoLavorazioneId: ''
          }));
          setSearchLavorazione('');
        }}
        title="Rimuovi selezione"
      >
        ✕
      </button>
    </div>
  )}
</div>
              </div>

              <div className="form-row">
  <div className="form-group">
    <label>Status Lavorazione *</label>
    <select
      value={newLavorazione.status}
      onChange={(e) => {
        const nuovoStatus = e.target.value;
        setNewLavorazione(prev => ({
          ...prev,
          status: nuovoStatus,
          dataFine: nuovoStatus === 'Lavorazione conclusa' ? new Date() : null
        }));
      }}
      className="form-select"
    >
      <option value="Lavorazione in corso">🔧 Lavorazione in corso</option>
      <option value="Lavorazione conclusa">✅ Lavorazione conclusa</option>
    </select>
  </div>

  <div className="form-group">
    <label>Ore Investite *</label>
    <input
      type="number"
      step="0.5"
      value={newLavorazione.oreInvestite}
      onChange={(e) => setNewLavorazione(prev => ({ ...prev, oreInvestite: e.target.value }))}
      className="form-input"
      placeholder="0"
    />
  </div>
</div>

<div className="form-row">
  <div className="form-group">
    <label>Km Mezzo</label>
    <input
      type="text"
      value={newLavorazione.kmMezzo}
      onChange={(e) => setNewLavorazione(prev => ({ ...prev, kmMezzo: e.target.value }))}
      className="form-input"
      placeholder="es: 150000"
    />
  </div>
</div>

              <div className="form-group">
                <label>Personale Assegnato</label>
                <div className="personale-assegnazione">
                  <button
                    onClick={handleAssegnaTutti}
                    className="btn-assegna-tutti"
                    type="button"
                  >
                    👥 Tutti
                  </button>
                  <div className="personale-checkboxes">
                    {formData.personalePresente.map(persona => (
                      <label key={persona.personaId} className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={newLavorazione.personaleAssegnato.some(p => p.personaId === persona.personaId)}
                          onChange={() => handleTogglePersonaleAssegnato(persona.personaId)}
                        />
                        <span>{persona.nome} {persona.cognome}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label>Note</label>
                <textarea
                  value={newLavorazione.note}
                  onChange={(e) => setNewLavorazione(prev => ({ ...prev, note: e.target.value }))}
                  className="form-textarea"
                  rows="3"
                  placeholder="Dettagli della lavorazione..."
                />
              </div>

              <div className="lavorazione-form-actions">
                <button
onClick={() => {
    setShowAddLavorazione(false);
    setNewLavorazione({
      mezzoId: '',
      tipoLavorazione: '',
      status: 'Lavorazione in corso',
      oreInvestite: '',
      personaleAssegnato: [],
      kmMezzo: '',
      note: '',
      dataInizio: new Date(),
      dataFine: null
    });
    setSelectedMezzoId('');  // ✅ AGGIUNTO
  }}
                  className="btn-cancel"
                  type="button"
                >
                  Annulla
                </button>
                <button
                  onClick={handleAddLavorazione}
                  className="btn-add"
                  type="button"
                >
                  ✅ Aggiungi Lavorazione
                </button>
              </div>
            </div>
          )}

          {formData.lavorazioni.length > 0 && (
            <div className="lavorazioni-list">
              <h4>Lavorazioni aggiunte:</h4>
              {formData.lavorazioni.map((lav, index) => (
                <div key={index} className="lavorazione-card">
               <div className="lavorazione-header">
    <strong>🚛 {lav.nomeMezzo}</strong>
    {lav.targaMezzo && <span className="badge-targa">{lav.targaMezzo}</span>}
    {/* ✅ AGGIUNTO: Badge Status */}
    <span className={`badge-status ${lav.status === 'Lavorazione conclusa' ? 'conclusa' : 'in-corso'}`}>
      {lav.status === 'Lavorazione conclusa' ? '✅' : '🔧'} {lav.status}
    </span>
  </div>
  <div className="lavorazione-body">
    <p><strong>Lavorazione:</strong> {lav.tipoLavorazione}</p>
    <p><strong>Ore:</strong> {lav.oreInvestite} ore</p>
    {lav.kmMezzo && <p><strong>Km:</strong> {lav.kmMezzo}</p>}
                    {lav.personaleAssegnato && lav.personaleAssegnato.length > 0 && (
                      <p><strong>Personale:</strong> {lav.personaleAssegnato.map(p => `${p.nome} ${p.cognome}`).join(', ')}</p>
                    )}
                    {lav.note && <p><strong>Note:</strong> {lav.note}</p>}
                  </div>
                  <button
                    onClick={() => handleRemoveLavorazione(index)}
                    className="btn-remove-lavorazione"
                  >
                    🗑️ Rimuovi
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Sezione Note */}
        <div className="form-section">
          <h3>📝 Note Generali</h3>
          <textarea
            value={formData.noteVarie}
            onChange={(e) => setFormData(prev => ({ ...prev, noteVarie: e.target.value }))}
            className="form-textarea"
            rows="4"
            placeholder="Note generali del rapportino..."
          />
        </div>

        {/* Azioni finali */}
        <div className="form-actions-final">
          <button onClick={onBack} className="btn-secondary" disabled={isSaving}>
            Annulla
          </button>
          <button onClick={handleSave} className="btn-primary" disabled={isSaving}>
            {isSaving ? '💾 Salvataggio...' : '💾 Salva Rapportino'}
          </button>
        </div>
      </div>

      {/* Modal Nuova Lavorazione */}
      {showNuovaLavorazioneModal && (
        <div className="modal-overlay" onClick={() => setShowNuovaLavorazioneModal(false)}>
          <div className="modal-content-small" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>➕ Nuova Lavorazione</h3>
              <button onClick={() => setShowNuovaLavorazioneModal(false)} className="modal-close">✕</button>
            </div>
            <div className="modal-body">
              <input
                type="text"
                value={nuovaLavorazioneNome}
                onChange={(e) => setNuovaLavorazioneNome(e.target.value)}
                placeholder="Nome lavorazione..."
                className="form-input"
                autoFocus
              />
            </div>
            <div className="modal-footer">
              <button onClick={() => setShowNuovaLavorazioneModal(false)} className="btn-secondary">
                Annulla
              </button>
              <button onClick={handleCreateNuovaLavorazione} className="btn-primary">
                ✅ Crea
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CapoOfficinaRapportinoForm;